// extracted by mini-css-extract-plugin
module.exports = {"container":"_1Zvy_","notification":"u-ETm","alert":"_3kyZF","success":"_3az_F","error":"_1Aw6G","text":"_1JLem","icon":"_3fsFV"};